import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { Link } from 'react-router-dom';
import './CMRDetailedReport.css'
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { format, set } from 'date-fns';
import pomisHeaderImage from './pomisHeader.jpeg';
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const CMRDetailedReport = () => {
    const [fpsOptions, setFpsOptions] = useState([]); // Store the fetched FPS options
    const [districtUid, setDistrictUid] = useState(''); // Store districtUid for reports
    const [isDistrictSelected, setIsDistrictSelected] = useState(false); // To track if the district is already selected
    const [isSubDivisionSelected, setIsSubDivisionSelected] = useState(false); // To track if the district is already selected
    const [isBlockSelected, setIsBlockSelected] = useState(false);
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState('');
    const [panchayatUidP, setpanchayatUidP] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    const [godownId, setGodownId] = useState("");
    const [godownUniqueId, setGodownUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [startDateP, setStartDate] = useState(null);
    const [endDateP, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [error, setError] = useState(null);  // Define setError here
    const [isOpen, setIsOpen] = useState(false);
    const [reportData, setReportData] = useState([]);  // State to hold report data
    const [showDownloadButton, setShowDownloadButton] = useState(false);  // Control visibility of DOWNLOAD PDF button
    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    const [sortedStockData, setSortedStockData] = useState([]);
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(2025, 0, 1); // January 1st of current year
    const location = useLocation();
    const godownIdFromQuery = new URLSearchParams(location.search).get('godownId'); // Get fpsId from query params
    const [selectedRows, setSelectedRows] = React.useState(new Set());
    // Highlight the row corresponding to the fpsId
    const getRowClass = (godownId) => {
        return godownId === godownIdFromQuery ? 'highlight-row' : '';
    };
    //console.log('7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5', token); // Debugging step: Ensure the token is correctly set
    const handleViewReportClick = (godownId, startTime, username) => {
        // Save fpsId and date to localStorage or sessionStorage
        localStorage.setItem('godownId', godownId);
        localStorage.setItem('startTime', startTime);
        localStorage.setItem('username', username); // Make sure username is set here
    };
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userInfo, setUserInfo] = useState({
        // displayName: '',
        // empId: ''
        fullName: '',
        employeeId: '',
        id: '',
        username: '',
    });

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const loginTime = localStorage.getItem('loginTime');

        if (userData) {
            // Extract the first name from fullName (only the first word)
            const firstName = userData.fullName.split(' ')[0];

            // Set the state with firstName and employeeId
            setUserInfo({
                fullName: firstName,  // Only first name is considered
                employeeId: userData.employeeId,
                id: userData.id,
                username: userData.username,
            });
            setIsLoggedIn(true);
            // setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
        } else {
            setIsLoggedIn(false);
        }
    }, []);
    //   const [isLoggedIn, setIsLoggedIn] = useState(false);
    //  const [userInfo, setUserInfo] = useState({
    //     fullName: '',
    //     employeeId: '',
    //     roleName: '',
    //    // districtUid:'',
    //    // subDivisionUid: '',
    //    // blockUid:'',
    //   });
    //   useEffect(() => {
    //       const userData = JSON.parse(localStorage.getItem('user'));

    //       if (userData) {
    //         // Extract the first name from fullName (only the first word)
    //         const firstName = userData.fullName.split(' ')[0];

    //         // Set the state with firstName, employeeId, and distriUid from userData
    //         setUserInfo({
    //           fullName: firstName,  // Only first name is considered
    //           employeeId: userData.employeeId,
    //           roleName: userData.roleName,
    //         //  districtUid: userData.districtUid, // Use dynamic districtUid if available
    //          // subDivisionUid:userData.subDivisionUid,
    //         //  blockUid:userData.blockUid,
    //         });
    //         setIsLoggedIn(true);
    //       } else {
    //         setIsLoggedIn(false);
    //       }
    //     }, []);
    //     useEffect(() => {
    //         if (isLoggedIn) {
    //      //     console.log(userInfo.districtUid); // This will log the updated distriUid
    //        //   console.log(userInfo.subDivisionUid);
    //        //   console.log(userInfo.blockUid);
    //         }
    //       }, [userInfo]);
    // const fetchReport = async (fpsId, date) => {
    //     try {
    //         const response = await axios.get(`http://13.233.181.205:1337/api/survey/reports/fps/${fpsId}/date/${date}`, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //             },
    //         });

    //         if (response.status === 200) {
    //             setReportData(response.data);  // Successfully fetched the report
    //         } else {
    //             throw new Error('Failed to fetch data');
    //         }
    //     } catch (error) {
    //         console.error('Error fetching report:', error);
    //     }
    // };

    //   const handleViewReportClick = (fpsId, date) => {
    //     // Fetch the report data
    //     fetchReport(fpsId, date);

    //     // Optionally, you can redirect to the report in a new tab using the reportUrl from the response
    //     // If the report URL is part of your response, use it like this:
    //     // window.open(reportUrl, '_blank');
    //   };


    const generateXl = () => {
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('CMR ATR Detailed Report');
        worksheet.mergeCells('A1:R1'); // Merge cells for the title
        // Set the cell value with both the date and time
        /// Set the title in the merged cells
        worksheet.getCell('A1').value = `CMR ATR Detailed Report`;

        // Center-align the text in the merged cell
        worksheet.getCell('A1').alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { bold: true, size: 12 };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { size: 16, bold: true, color: { argb: 'F7912B' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' }  // Background color: Whitesmoke (ARGB format)
        };

        // worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.mergeCells('A2:R2'); // Merge cells for the title
        // Set the cell value with both the date and time
        /// Set the title in the merged cells
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`;

        // Center-align the text in the merged cell
        worksheet.getCell('A2').alignment = { horizontal: 'center' };


        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.getRow(2).font = { bold: true, size: 12 };
        worksheet.getRow(2).alignment = { horizontal: 'right' };
        worksheet.getRow(2).font = { size: 11, bold: true, color: { argb: '000000' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: '000000' }  // Background color: Whitesmoke (ARGB format)
        };

        // Date formatting (if dates are present)
        const fromDate = startDateP ? `${startDateP.getDate().toString().padStart(2, '0')}-${(startDateP.getMonth() + 1).toString().padStart(2, '0')}-${startDateP.getFullYear().toString().slice()}` : '';
        const toDate = endDateP ? `${endDateP.getDate().toString().padStart(2, '0')}-${(endDateP.getMonth() + 1).toString().padStart(2, '0')}-${endDateP.getFullYear().toString().slice()}` : '';
        //console.log("fromDate:", fromDate);
        // console.log("toDate:", toDate);
        // worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.mergeCells('A3:R3'); // Merge cells for the title
        // Set the cell value with both the date and time
        /// Set the title in the merged cells
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`;

        // Center-align the text in the merged cell
        worksheet.getCell('A3').alignment = { horizontal: 'center' };


        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.getRow(3).font = { bold: true, size: 12 };
        worksheet.getRow(3).alignment = { horizontal: 'left' };
        worksheet.getRow(3).font = { size: 11, bold: true, color: { argb: '000000' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(3).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: '000000' }  // Background color: Whitesmoke (ARGB format)
        };
        worksheet.addRow(['S.No', 
            'District', 'Sub Division', 
            'Officer Name', 'Date of Inspection', 
             'Godown Name', 'Stock Difference (Parboiled- Rice) MT',
              'Type of Deviation (Parboiled Rice)','Stock Difference (Raw- Rice) MT',
              'Type of Deviation (Raw Rice)','Stock Difference (Wheat) MT',
              'Type of Deviation (Wheat)','Bad Quality of food grains',
              'Godown Closed','Action Initiated',
              'Remarks','Final Decision Taken','Final Remarks'
            ]);

        // Apply header style: bold, size 12, and orange background


        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 18; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 25 },  // Column C width
            { key: 'D', width: 25 },  // Column D width
            { key: 'E', width: 25 },  // Column E width
            { key: 'F', width: 50 },  // Column F width
            { key: 'G', width: 25 },  // Column D width
            { key: 'H', width: 35 },  // Column E width
            { key: 'I', width: 35 },
            { key: 'J', width: 25 },  // Column E width
            { key: 'K', width: 25 },  // Column F width
            { key: 'L', width: 25 },  // Column D width
            { key: 'M', width: 35 },  // Column E width
            { key: 'N', width: 35 },
            { key: 'O', width: 25 },  // Column F width
            { key: 'P', width: 25 },  // Column D width
            { key: 'Q', width: 35 },  // Column E width
            { key: 'R', width: 35 },
        ];

        // Add data rows from stockData
        stockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1, // S.No
                capitalizeFirstLetter(data.districtName || 'N/A'),
                capitalizeFirstLetter(data.subDivisionName || 'N/A'),
                capitalizeFirstLetter(data.officerName || 'N/A'),
                capitalizeFirstLetter(data.dateOfInspection || 'N/A'),
                data.godownName || "N/A",
               (data.paraboiledRice && parseFloat(data.paraboiledRice) !== 0 ? parseFloat(data.paraboiledRice).toFixed(3) : "-"),
                (data.typeOfStockDifferenceParaboiledRice &&
                    data.typeOfStockDifferenceParaboiledRice !== "No Difference"
                    ? data.typeOfStockDifferenceParaboiledRice
                    : "-"),

                (data.rawRice && parseFloat(data.rawRice) !== 0 ? parseFloat(data.rawRice).toFixed(3) : "-"),
                (data.typeOfStockDifferenceRawRice &&
                    data.typeOfStockDifferenceRawRice !== "No Difference"
                    ? data.typeOfStockDifferenceRawRice
                    : "-"),
                (data.stockDifferenceWheat && parseFloat(data.stockDifferenceWheat) !== 0 ? parseFloat(data.stockDifferenceWheat).toFixed(3) : "-"),

                (data.typeOfStockDifferenceWheatCmr &&
                    data.typeOfStockDifferenceWheatCmr !== "No Difference"
                    ? data.typeOfStockDifferenceWheatCmr
                    : "-"),
                data.badQuality === "NO" ? "-" : capitalizeWords(data.badQuality || "N/A"),
                data.godownClosed === "NO" ? "-" : capitalizeWords(data.godownClosed || "N/A"),
                getActionInitiatedLabel(data.actionInitiated),
                capitalizeWords(data.actionRemarks || "-"),
                getActionInitiatedLabel(data.finalDecision),
                capitalizeWords(data.finalRemarks || "-"),
               // data.fpsId || "N/A",
                // format(new Date(data.startTime), 'dd-MM-yyyy HH:mm:ss') || "N/A",
                // 'View Report' // Placeholder or dynamic link
            ]);

            // Adjust alignment for 'fpsId' (column 6) and 'startTime' (column 7) and center 'S.No' (column 0)
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {  // Column 0 (S.No)
                    cell.alignment = { horizontal: 'center' };  // Center align for S.No
                } else if (colNumber === 6 || colNumber === 7) {  // Columns 6 (fpsId) and 7 (startTime)
                    cell.alignment = { horizontal: 'right' };  // Right align for fpsId and startTime
                } else {
                    cell.alignment = { horizontal: 'left' };  // Left align for all other columns
                }
            });

        });

        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'CMR_ ATR_Detailed_Report.xlsx';
            link.click();
        });
    }
    // const handleGodownIdChange = (selectedOption) => {
    //     setFpsId(selectedOption ? selectedOption.value : ''); // Update state based on dropdown or typed value
    // };
    const generatePDF = () => {
        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [233, 290] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9.5, 1, 215, 40);  // Image format: 'PNG'
        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        const title = 'CMR ATR Detailed Report';  // Title for the report

        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);

        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        // const fps = fpshops.find(f => String(f.id) === String(godownUniqueId));
        const fps = Object.values(fpshops).find(f => String(f.id) === String(godownUniqueId));
        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        const fpsName = fps ? fps.fpsId : godownUniqueId; // If not found in fpshops, use the typed fpsId

        console.log(" godownUniqueId:", godownUniqueId);
        console.log(" fpsId:", godownUniqueId);
        // Date formatting (if dates are present)
        const fromDate = startDateP ? `${startDateP.getDate().toString().padStart(2, '0')}-${(startDateP.getMonth() + 1).toString().padStart(2, '0')}-${startDateP.getFullYear().toString().slice()}` : '';
        const toDate = endDateP ? `${endDateP.getDate().toString().padStart(2, '0')}-${(endDateP.getMonth() + 1).toString().padStart(2, '0')}-${endDateP.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        let currentYPosition = 55.21;
        let xPosition = 10;
        const columnSpacing = 71; // Space between columns

        // Check if there is data for each table
        const hasDistrict = districtName !== '';
        const hasSubDivision = subDivisionName !== '';
        const hasBlock = blockName !== '';

        const hasPanchayat = panchayatName !== '';
        const hasFps = fpsName !== '';

        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        // First Table (District, Sub Division, Block)
        if (hasDistrict || hasSubDivision || hasBlock) {
            // First Table (District, Sub Division, Block)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the first table

            // Set font to normal for labels
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);

            // Add labels for District, Sub Division, Block
            if (hasDistrict) {
                doc.text("District:", xPosition + 5, currentYPosition + 5);
            }
            if (hasSubDivision) {
                doc.text("Sub Division:", xPosition + columnSpacing * 1.15, currentYPosition + 5);
            }
            if (hasBlock) {
                doc.text("Block:", xPosition + columnSpacing * 2.20, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

            // Add dynamic data for District, Sub Division, Block
            if (hasDistrict) {
                doc.text(capitalizeFirstLetter(districtName), xPosition + 28, currentYPosition + 5);
            }
            if (hasSubDivision) {
                doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing + 37, currentYPosition + 5);
            }
            if (hasBlock) {
                doc.text(capitalizeFirstLetter(blockName), xPosition + columnSpacing * 2.02 + 28, currentYPosition + 5);
            }

            currentYPosition += 8;  // Move down for the next row

            // Second Table (Panchayat, FPS ID)
            if (hasPanchayat || hasFps) {
                // Second Table (Panchayat, FPS ID)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

                // Set font to normal for labels (Panchayat, FPS ID)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for Panchayat, FPS ID
                if (hasPanchayat) {
                    doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
                }
                if (hasFps) {
                    doc.text("FPS ID:", xPosition + columnSpacing * 1.35, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Green color for dynamic data

                // Add dynamic data for Panchayat and FPS ID
                if (hasPanchayat) {
                    doc.text(capitalizeFirstLetter(panchayatName), xPosition + 28, currentYPosition + 5);
                }
                if (hasFps) {
                    doc.text(capitalizeFirstLetter(fpsName), xPosition + columnSpacing + 41, currentYPosition + 5);
                }

                currentYPosition += 8;  // Move down for the next row

                // If third table has data, show it
                if (hasFromDate || hasToDate) {
                    // Third Table (From Date, To Date)
                    doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                    // Set font to normal for labels (From Date, To Date)
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                    // Add labels for From Date and To Date
                    if (hasFromDate) {
                        doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                    }
                    if (hasToDate) {
                        doc.text("To Date:", xPosition + columnSpacing * 1.15, currentYPosition + 5);
                    }

                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                    // Add dynamic data for From Date and To Date
                    if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                    if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 30, currentYPosition + 5);  // To Date (dynamic)

                    currentYPosition += 8;  // Move down for the next row
                }
            }

            // If second table has no data, show third table (From Date, To Date)
            else if (!hasPanchayat && !hasFps && (hasFromDate || hasToDate)) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing * 1.15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 30, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the first table has no data, show second table (Panchayat, FPS ID) if it has data
        else if (hasPanchayat || hasFps) {
            // Second Table (Panchayat, FPS ID)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for Panchayat, FPS ID
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasFps) {
                doc.text("Godown ID:", xPosition + columnSpacing * 1.35, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data

            // Add dynamic data for Panchayat and FPS ID
            if (hasPanchayat) {
                doc.text(capitalizeFirstLetter(panchayatName), xPosition + 28, currentYPosition + 5);
            }
            if (hasFps) {
                doc.text(capitalizeFirstLetter(fpsName), xPosition + columnSpacing + 41, currentYPosition + 5);
            }

            currentYPosition += 8;  // Move down for the next row

            // If third table has data, show it
            if (hasFromDate || hasToDate) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing * 1.15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 30, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the second table has no data, show the third table (From Date, To Date)
        else if (hasFromDate || hasToDate) {
            // Third Table (From Date, To Date)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for From Date and To Date
            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing * 1.15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

            // Add dynamic data for From Date and To Date
            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 30, currentYPosition + 5);  // To Date (dynamic)

            currentYPosition += 8;  // Move down for the next row
        }

        currentYPosition += 5;  // Adjust space for next content if needed


        currentYPosition += 5;  // Adjust space for next content if needed

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition, { align: 'right' });
        currentYPosition += 5;
        // Generate the rest of the table (data rows, etc.) if required
        const headers = [
            "S. No.",
            "District",
            "Sub-Division",
            "Block",
            "Panchayat",
            "Godown ID",
            "Godown Name",
            "Date of Inspection",
            "Name of Inspecting Officer"
        ];

        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.districtName || 'N/A'),
            capitalizeFirstLetter(data.subDivisionName || 'N/A'),
            capitalizeFirstLetter(data.blockName || 'N/A'),
            capitalizeFirstLetter(data.panchayatName || 'N/A'),
            data.godownId || 'N/A',
            data.godownName || "N/A",
            format(new Date(data.startTime), 'dd-MM-yyyy'),
            formatFullName(data.officerName || 'N/A')
        ]);
        doc.autoTable({
            head: [headers],
            body: rows,
            startY: currentYPosition,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },  // S.No - Center alignment
                1: { cellWidth: 23, halign: 'left' },    // District - Left alignment
                2: { cellWidth: 25, halign: 'left' },    // Subdivision - Left alignment
                3: { cellWidth: 25, halign: 'left' },    // Block Name - Left alignment
                4: { cellWidth: 25, halign: 'left' },    // Panchayat Name - Left alignment
                5: { cellWidth: 26, halign: 'right' },   // godown ID - Right alignment
                6: { cellWidth: 25, halign: 'left' },
                7: { cellWidth: 22, halign: 'right' },   // Start Time - Right alignment
                8: { cellWidth: 30, halign: 'left' },    // POIMS User - Left alignment
            },
            tableWidth: 'auto',
            margin: {
                horizontal: 10,
                top: 10,
                bottom: 10,
            },
            pageBreak: 'auto',
            showHead: 'firstPage',
            styles: {
                fontSize: 10,
                textColor: 0,
            },
            headStyles: {
                fontSize: 8,
                fontStyle: 'bold',
                textColor: [42, 109, 139],
                fillColor: [211, 211, 211],
            }
        });

        // Save the generated PDF
        doc.save('CMR_ ATR_Detailed_Report.pdf');
    };

    // Handle Start Date Change
    const handleStartDateChange = (date) => {
        setStartDate(date); // Set the selected start date
        setEndDate(''); // Clear the end date when start date changes
        setShowCalendar(false); // Hide the start date calendar after selection
        setShowEndCalendar(false); // Hide the end date calendar
    };

    // Handle End Date Change
    const handleEndDateChange = (date) => {
        setEndDate(date); // Set the selected end date
        setShowEndCalendar(false); // Hide the end date calendar
    };

    // Show the End Date calendar
    const handleEndDateClick = () => {
        // Only show the calendar for endDateP if startDateP is selected
        if (startDateP) {
            setShowEndCalendar(true);
        }
    };
    // Token you provided (for testing purposes)
    // const token = '7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5';
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const godownUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;


    useEffect(() => {
        if (token) {

            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },

                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            // Extract districtUid from the userData
            const userDistrictUid = userData.districtUid;

            // Set the districtId based on districtUid from the login payload
            const selectedDistrict = districts.find(dist => dist.districtUid === userDistrictUid);
            if (selectedDistrict) {
                setDistrictId(selectedDistrict.id); // Set districtId for the selected district
                setDistrictUid(selectedDistrict.districtUid); // Set districtUid for the report generation
                setIsDistrictSelected(true); // Set flag to indicate the district is selected
            }
        }
    }, [districts]);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            // Extract districtUid from the userData

            const userSubDivisionUid = userData.subDivisionUid;
            // Set the districtId based on districtUid from the login payload
            const selectedSubDivision = subDivisions.find(sub => sub.subDivisionUid === userSubDivisionUid);
            if (selectedSubDivision) {
                setSubDivisionId(selectedSubDivision.id); // Set districtId for the selected district
                setSubDivisionUid(selectedSubDivision.subDivisionUid); // Set districtUid for the report generation
                setIsSubDivisionSelected(true); // Set flag to indicate the district is selected
            }
        }
    }, [subDivisions]);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            // Extract districtUid from the userData

            const userBlockUid = userData.blockUid;
            // Set the districtId based on districtUid from the login payload
            const selectedBlock = blocks.find(b => b.blockUid === userBlockUid);
            if (selectedBlock) {
                setBlockId(selectedBlock.id); // Set districtId for the selected district
                setBlockUid(selectedBlock.blockUid); // Set districtUid for the report generation
                setIsBlockSelected(true); // Set flag to indicate the district is selected
            }
        }
    }, [blocks]);
    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };

    useEffect(() => {
        if (districtId) {
            fetchSubDivisions(districtId);
        }
    }, [districtId]); // Re-fetch subdivisions when districtId changes

    useEffect(() => {
        if (subDivisionId) {
            fetchBlocks(subDivisionId);
        }
    }, [subDivisionId]); // Re-fetch subdivisions when districtId changes
    useEffect(() => {
        if (blockId) {
            fetchPanchayats(blockId);
        }
    }, [blockId]);

    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };

    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };
    // useEffect(() => {
    //     if (token) {
    //         // If no filters are selected, fetch all FPS
    //         fetchFPShops();
    //     } else {
    //         setError("No token found. Please log in.");
    //     }
    // }, []); // Empty dependency array means this effect runs only once when the component mounts

    // Fetch FPS based on Panchayat or fetch all FPS if no filters are selected
    // const fetchFPShops = async (panchayatId = null) => {
    //     if (panchayatId) {
    //         // If Panchayat ID is selected, fetch FPS based on Panchayat
    //         try {
    //             const response = await axios.get(`${baseUrl}/villages?filters[panchayat][id][$eq]=${panchayatId}&populate=fairPriceShops&pagination[pageSize]=100`, {
    //                 headers: { Authorization: `Bearer ${token}` },
    //             });
    //             const fpsData = response.data.data || [];
    //             const allFps = fpsData.flatMap(item => item.fairPriceShops);
    //             setFPShops(allFps || []);  // Update state with filtered FPS data
    //         } catch (error) {
    //             console.error('Error fetching fpshops by panchayat:', error);
    //             setError("Error fetching FPS by Panchayat");
    //         }
    //     }

    // };
    const fetchGodownOptions = async () => {
        setIsLoading(true); // Show loading indicator

        // Construct request payload
        const requestData = {};

        if (districtUid) {
            requestData.district = districtUid;
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid) {
            requestData.block = blockUid;
        }
        if (panchayatUidP) {
            requestData.panchayat = panchayatUidP;
        }
        requestData.surveyType = "1";
        try {
            const response = await axios.post(`${godownUrl}/get-godown-by-filters`, requestData, {
                headers: { Authorization: `Bearer ${token}` },

            });

            if (response.data && response.data.data) {
                setFpsOptions(response.data.data); // Set the fetched FPS options
            } else {
                setFpsOptions([]);
                setError("No FPS data found for the selected filters.");
            }
        } catch (error) {
            setError("Error fetching FPS options.");
            console.error('Error fetching FPS options:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };

    useEffect(() => {
        // Fetch FPS options whenever the filters change
        if (districtUid || subDivisionUid || blockUid || panchayatUidP) {
            fetchGodownOptions();
        }
    }, [districtUid, subDivisionUid, blockUid, panchayatUidP]);

    const handleFpsSelection = (selectedFpsId) => {
        setGodownId(selectedFpsId); // Store the selected FPS ID
    };



    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports
        const selectedDivisionName = selectedOption ? selectedOption.label : "";
        console.log('name of dis', selectedDivisionName);
        console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation

        // Set both districtId (for filtering) and districtUid (for report generation)
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setpanchayatUidP('');  // Clear panchayatUidP
        setBlockUid('');
        setGodownUniqueId('')
        // Reset other state
        setSubDivisionId('');
        setBlockId('');

        setGodownId('');

        setFPShops([]);
        setPanchayats([]);
        setBlocks([]);
        setShowTable(false);

        // Fetch subdivisions based on districtId (for filtering)
        fetchSubDivisions(selectedDistrictId);

    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        // const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        const selectdSubDivisionName = selectedOption ? selectedOption.label : "";
        console.log('name of sub-div', selectdSubDivisionName);
        console.log('Selected Subdivision:', selectedId);
        console.log('Selected selectdSubDivisionUid:', selectdSubDivisionUid);

        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid);

        setSubDivisionId(selectedId);
        //setSubDivisionUid('');  // Clear subDivisionUid
        setpanchayatUidP('');  // Clear panchayatUidP
        setBlockUid('');
        setGodownUniqueId('')
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setGodownId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops 
        setPanchayats([])  //it is not actved panchayats without selecting
        setBlocks([]) //it is not actved block  without selecting
        setShowTable(false);  // Reset table visibility
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision
    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        //  const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        const selectdBlockName = selectedOption ? selectedOption.label : "";
        console.log('name of block', selectdBlockName);
        console.log('Selected Block:', selectedId);
        console.log('Selected BlockUid:', selectedBlockUid);
        console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);
        setBlockUid(selectedBlockUid);

        // setSubDivisionUid('');  // Clear subDivisionUid
        setpanchayatUidP('');  // Clear panchayatUidP
        setGodownUniqueId('')
        // setBlockUid('');
        setPanchayatId('');  // Reset panchayat
        setGodownId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([])  //it is not actved panchayats  without selecting
        setShowTable(false);  // Reset table visibility
        fetchPanchayats(selectedId);  // Fetch panchayats based on the selected block
    };

    const handlePanchayatChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        // const selectedpanchayatUidP = selectedOption ? selectedOption.panchayatUidP : '';
        const selectedpanchayatUidP = selectedOption ? selectedOption.panchayatUidP : '';
        const selectdPanName = selectedOption ? selectedOption.label : "";
        console.log('name of pan', selectdPanName);
        console.log('Selected Panchayat:', selectedId);
        console.log("selected panUid", selectedpanchayatUidP);
        setpanchayatUidP(selectedpanchayatUidP);
        console.log("selected panUid", selectedpanchayatUidP);
        setpanchayatUidP(selectedpanchayatUidP);
        // Reset only FPS ID, as panchayat is selected
        setPanchayatId(selectedId);
        //  setpanchayatUidP('');
        setGodownUniqueId('');
        setGodownId('');  // Reset godown ID
        setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        setShowTable(false);  // Reset table visibility
        //  fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
    };

    const handleGodownId = (selectedOption) => {
        const selectedGodownId = selectedOption ? selectedOption.value : '';
        const selectedGodownUniqueId = selectedOption ? selectedOption.label : '';

        console.log('Selected FPS:', selectedGodownId);
        console.log('unique normal ', selectedGodownUniqueId)
        setGodownId(selectedGodownId);  // Save the selected FPS ID
        setGodownUniqueId(selectedGodownUniqueId);  // Save the selected FPS Unique ID
        //setGodownUniqueId('');
        // setFpsId('');  
        setShowTable(false);  // Show the table after FPS ID is selected
    };


    // Function to clear all data (reset state)
    const handleClear = () => {
        setGodownId('');
        setDistrictUid('');
        //setBlockUid('');
        setpanchayatUidP('');
        //setSubDivisionUid('');
        // setDistrictUid('');
        setDistrictId('');
        // setSubDivisionId('');
        // setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        // setFpsId('');
        setFPShops('');
        setShowDownloadButton(false);
        setShowTable(false);
    };
    const handleGenerateReport = () => {
        setIsLoading(true);
        setShowTable(true);
        // Case 1: Ensure start date is before end date (basic validation)
        if (startDateP && endDateP && startDateP > endDateP) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }


        setStockData([]);  // Clear previous stock data

        // Prepare request data
        const requestData = {};

        if (startDateP) {
            requestData.startDate = formatDate(startDateP);
        }

        if (endDateP) {
            requestData.endDate = formatDate(endDateP);
        }

        if (districtUid) {
            requestData.districtUid = districtUid;
            requestData.surveyType = "1";
        } else if (!districtUid && !godownId && !godownUniqueId) {
            // If no fpsId and no districtUid, set default as "All"
            requestData.districtUid = "All";
            requestData.surveyType = "1";
        }

        if (subDivisionUid) {
            requestData.subDivisionUid = subDivisionUid;
        }

        if (blockUid) {
            requestData.blockUid = blockUid;
        }

        // if (panchayatUidPP) {
        //     requestData.panchayatUidP = panchayatUidPP;
        // }

        if (panchayatUidP) {
            requestData.panchayatUid = panchayatUidP;
        }
        if (godownUniqueId) {
            requestData.godownId = godownUniqueId;  // Use godownUniqueId if it's available
        } else if (godownId) {
            requestData.godownId = godownId;  // Otherwise, use fpsId
        }


        console.log(requestData);  // Log the request data for debugging

        // Make the POST request to fetch the report
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-action-taken-report`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',  // Ensure content type is set
                },
            })
            .then((response) => {
                setIsLoading(false);  // Stop loading
                if (response.data && response.data.length > 0) {
                    // ✅ Filter only records with actionStatus = "close"
                    const filteredData = response.data.filter(item => 
                        item.actionStatus === "close" ||
                        item.actionStatus === "open" 
                    
                    );

                    if (filteredData.length > 0) {
                        setStockData(filteredData);
                        setShowDownloadButton(true);
                        setShowTable(true);
                    } else {
                        setStockData([]);
                        setError("No 'close' status records available for the selected filters.");
                        setShowDownloadButton(false);
                        setShowTable(true);
                    }
                } else {
                    setStockData([]);
                    setError("No data available for the selected filters.");
                    setShowDownloadButton(false);
                    setShowTable(true);
                }
            })
            .catch((error) => {
                setIsLoading(false);  // Stop loading
                setError("Error fetching report.");
                console.error('Error fetching report:', error);
                setShowDownloadButton(false);  // Hide download button if there was an error
                setShowTable(true);  // Show the table even if there's an error
            });
    };



    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };
    //const sortedStockData = sortData(stockData);

    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    //   const formatDate = (date) => {
    //     if (!date) return '';
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    //     const year = date.getFullYear();
    //     return `${day}-${month}-${year}`;
    // };
    // const formatDateToISO = (date) => {
    //     if (!date) return null;
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    //     const year = date.getFullYear();
    //     return `${year}-${month}-${day}`;  // Format as YYYY-MM-DD
    // };

    // const requestData = {
    //     fpsId: godownUniqueId,
    //     startDateP: startDateP ? formatDateToISO(startDateP) : null,
    //     endDateP: endDateP ? formatDateToISO(endDateP) : null,
    // };


    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };
    // useEffect(() => {
    //     if (districtId) {
    //         fetchFpshops(districtId);  // Fetch FPS shops when district is selected
    //     } else {
    //         setFpshops([]);  // Clear FPS shops if no district is selected
    //     }
    // }, [districtId]);

    //   const handleDistrictChange = (selectedOption) => {
    //     const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
    //     setDistrictId(selectedDistrictId);  // Set districtId state
    //   };

    const handleGodownIdChange = (selectedOption) => {
        const selectedFpsId = selectedOption ? selectedOption.value : '';
        setGodownId(selectedFpsId);  // Set FPS ID state
    };

    //   const toggleDropdown = () => {
    //     setIsOpen(!isOpen);  // Toggle dropdown visibility
    //   };
    // const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const username = queryParams.get('username');
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const panchayatUid = queryParams.get('panchayatUid'); // Fixed typo here

    useEffect(() => {
        console.log("Query Params:", queryParams.toString());
        console.log("Username:", username);
        console.log("Panchayat UID:", panchayatUid);
        console.log("Start Date:", startDate);
        console.log("End Date:", endDate);

        if (username && startDate && endDate) {
            const fetchInspectionData = async () => {
                setIsLoading(true);
                try {
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-inspection`,
                        { username, panchayatUid, startDate, endDate },
                        { headers: { Authorization: `Bearer ${token}` } }
                    );

                    console.log('Fetched data:', response.data);
                    setStockData(response.data);
                    setShowTable(true);
                } catch (error) {
                    console.error('Error fetching inspection data:', error);
                } finally {
                    setIsLoading(false);
                }
            };

            fetchInspectionData();
        } else {
            setIsLoading(false);
        }
    }, [username, startDate, endDate, token, panchayatUid]);
    //console.log('sortedStockData:', sortedStockData);

    const handleDropdownChange = (godownId, field, value) => {
        setStockData(prev => {
            const newData = [...prev];
            const index = newData.findIndex(entry => entry.godownId === godownId);
            if (index !== -1) {
                newData[index] = { ...newData[index], [field]: value };
            }
            return newData;
        });
    };


    const capitalizeWords = (str) => {
        if (!str || typeof str !== "string") return "";
        return str
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const handleSubmit = () => {
        const selectedIndexes = Array.from(selectedRows);

        if (selectedIndexes.length === 0) {
            alert("Please select at least one row before submitting.");
            return;
        }

        const payload = selectedIndexes
            .map(index => sortedStockData[index])
            .filter(entry => entry && entry.actionType && entry.actionType.trim()) // ✅ safe check here
            .map(entry => {
                let status = "";
                let finalAction = null;
                const action = (entry.actionType || "").trim().toLowerCase();

                if (action === "notice" || action === "fir") {
                    status = "open";
                } else if (action === "revoke" || action === "cancel license") {
                    status = "close";
                    finalAction = action;
                }

                return {
                    fairPriceShop: entry.fairPriceShop,
                    poimsUser: userInfo.id,
                    officerUserName: entry.officerUserName,
                    survey: entry.surveryId,
                    actionInitiated: entry.actionType || "",
                    actionStatus: status,
                    remarks: entry.remarksAction || "",
                    ...(finalAction && { finalAction }),
                };
            });

        if (payload.length === 0) {
            alert("No valid rows to submit.");
            return;
        }

        const finalPayload = { data: payload };

        setIsLoading(true);
        axios.post(`${baseUrl}/beneficiary-feedback-actions/create-many`, finalPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then(() => {
                alert("Existing Stock Verification submitted successfully!");

                // Clear selectedRows and reset action data from submitted rows
                const newData = [...sortedStockData];
                selectedIndexes.forEach(index => {
                    if (newData[index]) {
                        newData[index].actionType = "";
                        newData[index].remarksAction = "";
                    }
                });

                setSortedStockData(newData);
                setSelectedRows(new Set());
                // Refresh the table data
                handleGenerateReport();
            })

            .catch((error) => {
                console.error("❌ Error submitting:", error);
                alert("Failed to submit stock verification!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    // const handleUpdate = () => {
    //     const payload = sortedStockData
    //         .filter((entry) => entry.actionTaken === "revoke" || entry.actionTaken === "cancel license" || entry.actionTaken === "fir")
    //         .map((entry) => ({
    //              poimsUser: userInfo.id,
    //         godownId: entry.godownId,          // ✅ Add godownId
    //         officerUserName: entry.officerUserName, // ✅ Add officerUserName
    //         survey: entry.surveyId,            // ✅ surveyId
    //         finalAction: entry.actionTaken,
    //         actionStatus: "close",             // final action = closed
    //         finalRemarks: entry.finalRemarks || null // allow null if empty
    //         }));
    //     // ✅ If no dropdown selected, show alert and return
    //     if (payload.length === 0) {
    //         alert("Please select a Final Decision.");
    //         return;
    //     }


    //     const finalPayload = { data: payload };

    //     console.log("✅ Payload to submit:", finalPayload);

    //     axios.post(
    //         `${baseUrl}/beneficiary-feedback-actions/by-surveys`,
    //         finalPayload,
    //         {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 "Content-Type": "application/json",
    //             },
    //         }
    //     )
    //         .then(() => {
    //             alert("Existing Stock Verification successfully!");
    //             handleGenerateReport();
    //         })
    //         .catch((error) => {
    //             console.error("❌ Error submitting:", error);
    //             alert("Failed to submit stock verification!");
    //         });
    // };
    const handleUpdate = () => {
        const payload = stockData
            .filter(entry => entry.actionTaken === "revoke" || entry.actionTaken === "agm-suspended" || entry.actionTaken === "qc-suspended" || entry.actionTaken === "agm-qc-suspended")
            .map(entry => ({
                poimsUser: userInfo.id,
                godown: entry.godownAutoId,
                officerUserName: entry.officerUserName,
                survey: entry.surveyId,
                finalAction: entry.actionTaken,
                actionStatus: "close",
                finalRemarks: entry.finalRemarks || null
            }));

        if (payload.length === 0) {
            alert("Please select a Final Decision.");
            return;
        }

        axios.post(`${baseUrl}/beneficiary-feedback-actions/by-surveyss`, { data: payload }, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        })
            .then(() => {
                alert("Existing Stock Verification successfully!");
                handleGenerateReport();
            })
            .catch(error => {
                console.error("❌ Error submitting:", error);
                alert("Failed to submit stock verification!");
            });
    };

    const filteredData = sortedStockData.filter(
        entry =>
            (entry.actionInitiated === "notice" || entry.actionInitiated === "fir") &&
            entry.status !== "close"
    );

    const getActionInitiatedLabel = (value) => {
        switch (value?.toLowerCase()) {
            case "agm":
                return "Showcause issued to AGM";
            case "qc":
                return "Showcause issued to QC";
            case "agm-qc":
                return "Showcause issued to AGM and QC";
            case "revoke":
                return "Showcause Revoked";
            case "agm-suspended":
                return "AGM Suspended";
            case "qc-suspended":
                return "QC suspended";
            case "agm-qc-suspended":
                return "AGM and QC suspended";
            case "other":
                return "Any other action";
            case "salary-hold":
                return "Salary with Hold";   

            default:
                return value || "-";
        }
    };

    return (
        <div className="inspection-repo-cmrDATR">
            {/* <div className="fpsstockdeviationname">
                    <p>FPS Stock Deviation Report</p>
                </div> */}

            <div className="inspection-repo-drop-cmrDATR">
                <div className="inspection-card-head-cmrDATR ">CMR ATR Detailed Report</div>
                <div className='cmrDATR-whole-div'>
                    <div className="cmrDATR-main">
                        <div className="cmrDATR-group">
                            <label htmlFor="district" >
                                <span className="asterisk">*</span>District
                            </label>
                            <Select
                                className="cmrDATR-search-select"
                                id="district"
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,  // districtId for filtering
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts
                                    .sort((a, b) => a.districtName.localeCompare(b.districtName))  // Sort by districtName alphabetically
                                    .map((dist) => ({
                                        value: dist.id,  // Use districtId here for filtering
                                        label: capitalizeFirstLetter(dist.districtName),  // Show districtName as label
                                        districtUid: dist.districtUid,  // Include districtUid for report generation
                                    }))
                                }
                                isDisabled={isDistrictSelected}
                                placeholder="Select a district"
                                isSearchable  // Enable search
                                styles={customStyles}  // Apply custom styles
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}  // Trigger dropdown open
                                onMenuClose={toggleDropdown}  // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    ),
                                }}
                            />

                        </div>


                        <div className="cmrDATR-group">
                            {/* <label htmlFor="fpsId">Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="cmrDATR-search-select"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: fpsOptions.find((fps) => fps.id === godownId)?.godownId  // Use fpsId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={fpsOptions.sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((fps) => ({
                                            value: fps.id,
                                            label: fps.godownId,  // Display the fpsId as label
                                            godownUniqueId: fps.godownUniqueId,  // Include godownUniqueId for report generation
                                        }))}
                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="cmrDATR-search-select-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                    style={{ padding: '5px' }}
                                />
                            )} */}
                        </div>


                        <div className="cmrDATR-group-2">
                            <div className="cmrDATR-group-4">
                                <button className="inspection-button" onClick={handleClear}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDateP and endDateP are provided
                                        !(godownId || (districtUid && startDateP && endDateP) || (districtUid === null && startDateP && endDateP))
                                    }
                                >CLEAR
                                </button>


                                <button
                                    className="inspection-button"
                                    onClick={handleGenerateReport}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDateP and endDateP are provided
                                        !(godownId || (districtUid && startDateP && endDateP) || (districtUid === null && startDateP && endDateP))
                                    }  // Disable if any field is not selected
                                // disabled={!districtId }
                                >
                                    Generate Report
                                </button>
                            </div>

                        </div>

                    </div>



                    <div className="cmrDATR-block-3">
                        <div className="cmrDATR-group-3">
                            <label htmlFor="startDateP" ><span className="asterisk">*</span>From Date</label>
                            <div className="dates-setting-stock-complainsg">
                                <input
                                    type="text"
                                    id="startDateP"
                                    className="cmrinspection-input-repo"
                                    value={startDateP ? format(startDateP, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                />
                                <div className="cmrDATR-icon" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDateP}
                                        onChange={handleStartDateChange}
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>


                        <div className="cmrDATR-group-3">
                            <label htmlFor="startDateP" ><span className="asterisk">*</span>To Date</label>
                            <div className="dates-setting-stock-complainsg">
                                <input
                                    type="text"
                                    id="startDateP"
                                    className="cmrinspection-input-repo"
                                    value={endDateP ? format(endDateP, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    disabled={!startDateP}
                                />
                                <div className="cmrDATR-icon" onClick={handleEndDateClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDateP}

                                        onChange={handleEndDateChange}
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        //  minDate={minEndDate} // Disable dates before startDateP
                                        inline
                                        minDate={startDateP} // End date can't be before the start date
                                        maxDate={currentDate} // End date can't be after today
                                    />
                                )}
                            </div>
                        </div>

                        <div className="cmrDATR-group-3">

                            {/* Conditionally Render GET REPORT Button */}



                            {/* Conditionally Render DOWNLOAD PDF Button  (districtId && startDateP && endDateP) && */}
                            {((districtUid && startDateP && endDateP) || (districtUid === null && startDateP && endDateP) || (stockData.length > 0)) && showDownloadButton && showTable && (
                                <div className="cmrDATR-group-4">
                                    {/* <button onClick={generatePDF} className="inspection-button">
                                        DOWNLOAD PDF
                                    </button> */}
                                    <button onClick={generateXl} className="inspection-button">
                                        DOWNLOAD XLSX
                                    </button>
                                </div>
                            )}
                        </div>


                    </div>
                </div>
            </div>

            {/* <div>
                <button className="existingStock-button" onClick={handleUpdate}
                    disabled={isLoading || stockData.length === 0 || !(godownId || (districtUid) || (districtUid === null))

                    }
                >
                    Update
                </button>
            </div> */}
            <div className="cmrDATR-entry-repo">
                <table className="cmrDATR-table-repo">
                    <thead>
                        <tr>
                            <th rowSpan="2">S.No</th>
                            <th rowSpan="2">District</th>
                            <th rowSpan="2">Sub Division</th>
                            <th rowSpan="2">Officer Name</th>
                            <th rowSpan="2">Date of Inspection</th>
                            <th rowSpan="2">Godown Name</th>
                            <th rowSpan="2">Stock Difference (Parboiled- Rice) MT</th>
                            <th rowSpan="2">Type of Deviation (Parboiled Rice)</th>
                            <th rowSpan="2">Stock Difference (Raw- Rice) MT</th>
                            <th rowSpan="2">Type of Deviation (Raw Rice)</th>
                            <th rowSpan="2">Stock Difference (Wheat) MT</th>
                            <th rowSpan="2">Type of Deviation (Wheat)</th>
                            <th rowSpan="2">Bad Quality of Food Grains</th>
                            <th rowSpan="2">Godown Closed</th>
                            <th rowSpan="2">Action Initiated</th>
                            <th rowSpan="2">Remarks</th>
                            <th rowSpan="2">Final Decision Taken</th>
                            <th rowSpan="2">Final Remarks</th>

                        </tr>
                        {/* <tr>
                            <th>PHH Qty.</th>
                            <th>AAY Qty.</th>
                            <th>PHH Qty.</th>
                            <th>AAY Qty.</th>
                            <th>Rice</th>
                            <th>Wheat</th>
                            <th>Rice</th>
                            <th>Wheat</th>
                        </tr> */}
                    </thead>
                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="18" style={{ textAlign: "center" }}>Loading...</td>
                                </tr>
                            ) : stockData.length > 0 ? (
                                stockData.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{entry.districtName}</td>
                                        <td>{entry.subDivisionName}</td>
                                        <td>{entry.officerName || "N/A"}</td>
                                        <td>{new Date(entry.dateOfInspection).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                                        <td>{entry.godownName}</td>
                                         <td>{entry.paraboiledRice && parseFloat(entry.paraboiledRice) !== 0 ? parseFloat(entry.paraboiledRice).toFixed(3) : "-"}</td>
                                        <td>
                                            {entry.typeOfStockDifferenceParaboiledRice &&
                                                entry.typeOfStockDifferenceParaboiledRice !== "No Difference"
                                                ? entry.typeOfStockDifferenceParaboiledRice
                                                : "-"}
                                        </td>
                                        <td>{entry.rawRice && parseFloat(entry.rawRice) !== 0 ? parseFloat(entry.rawRice).toFixed(3) : "-"}</td>
                                        <td>
                                            {entry.typeOfStockDifferenceRawRice &&
                                                entry.typeOfStockDifferenceRawRice !== "No Difference"
                                                ? entry.typeOfStockDifferenceRawRice
                                                : "-"}
                                        </td>
                                        <td>{entry.stockDifferenceWheat && parseFloat(entry.stockDifferenceWheat) !== 0 ? parseFloat(entry.stockDifferenceWheat).toFixed(3) : "-"}</td>
                                        <td>
                                            {entry.typeOfStockDifferenceWheatCmr &&
                                                entry.typeOfStockDifferenceWheatCmr !== "No Difference"
                                                ? entry.typeOfStockDifferenceWheatCmr
                                                : "-"}
                                        </td>
                                        <td>{entry.badQuality === "NO" ? "-" : capitalizeWords(entry.badQuality || "N/A")}</td>
                                        <td>{(entry.godownClosed === "NO" || entry.godownClosed === "Unknown") ? "-" : capitalizeWords(entry.godownClosed || "N/A")}</td>
                                        <td>{getActionInitiatedLabel(entry.actionInitiated)}</td>

                                        <td>{capitalizeWords(entry.actionRemarks || "-")}</td>
                                        {/* Final Taken Dropdown */}
                                        <td>
                                            {getActionInitiatedLabel(entry.finalDecision)}
                                        </td>

                                        <td>
                                            {capitalizeWords(entry.finalRemarks || "-")}
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="18" style={{ textAlign: "center", color: "red" }}>No Data Available</td>
                                </tr>
                            )}
                        </tbody>
                    )}

                </table>

            </div>






        </div>
    );
};

export default CMRDetailedReport;